import { render } from "./test1.vue?vue&type=template&id=259033aa&scoped=true&ts=true"
import script from "./test1.vue?vue&type=script&lang=ts"
export * from "./test1.vue?vue&type=script&lang=ts"

import "./test1.vue?vue&type=style&index=0&id=259033aa&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259033aa"]])

export default __exports__